export default "__VITE_ASSET__BCuTcoDz__"